import {
	AlignCenterIcon,
	AlignLeftIcon,
	AlignRightIcon,
	AlignVerticalJustifyCenterIcon,
	AlignVerticalJustifyEndIcon,
	AlignVerticalJustifyStartIcon,
	RectangleVerticalIcon,
	SquareIcon,
} from "lucide-react";

export const TEXT_ALIGNMENT_OPTIONS = [
	{ value: "left", label: "", icon: <AlignLeftIcon className="size-3" />, tooltip: "Align left" },
	{ value: "center", label: "", icon: <AlignCenterIcon className="size-3" />, tooltip: "Align center" },
	{ value: "right", label: "", icon: <AlignRightIcon className="size-3" />, tooltip: "Align right" },
];

export const VERTICAL_ALIGNMENT_OPTIONS = [
	{
		value: "top",
		label: "Top",
		icon: <AlignVerticalJustifyStartIcon className="size-4 mr-1" />,
	},
	{
		value: "middle",
		label: "Middle",
		icon: <AlignVerticalJustifyCenterIcon className="size-4 mr-1" />,
	},
	{
		value: "bottom",
		label: "Bottom",
		icon: <AlignVerticalJustifyEndIcon className="size-4 mr-1" />,
	},
];

export const ASPECT_RATIO_OPTIONS = [
	{ value: "1/1", label: "1:1", icon: <SquareIcon className="size-3" />, tooltip: "Square (1:1)" },
	{
		value: "9/16",
		label: "9:16",
		icon: <RectangleVerticalIcon className="size-3" />,
		tooltip: "Portrait (9:16)",
	},
	{
		value: "3/4",
		label: "3:4",
		icon: <RectangleVerticalIcon className="size-3 scale-x-125" />,
		tooltip: "Portrait (3:4)",
	},
];

export const BUTTON_RADIUS_OPTIONS = [
	{ value: "none", label: "None" },
	{ value: "sm", label: "Small" },
	{ value: "md", label: "Medium" },
	{ value: "lg", label: "Large" },
	{ value: "full", label: "Full" },
];
